import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  Autocomplete,
  Typography,
  Backdrop,
  CircularProgress,
  IconButton,
  Button,
} from "@material-ui/core";
import Card from "../../../StyledComponents/Card/Card";
import CardHeader from "../../../StyledComponents/Card/CardHeader";
import CardText from "../../../StyledComponents/Card/CardText";
import CardBody from "../../../StyledComponents/Card/CardBody";
import { makeStyles } from "@material-ui/styles";
import VendorTaxTable from "../NewInvoice/Tables/Vendor_Tax_Detail";
// import TaxTable from "../NewInvoice/Tables/Tax_Table.jsx";
import TaxTableV2 from "../NewInvoice/Tables/TaxTableV2.jsx";
import { ArrowBack } from "@material-ui/icons";
import PODetail from "../NewInvoice/Tables/PoDetail_Table";
import { Download, Delete } from "@mui/icons-material";

import downloadAttachments from "../../../Functions/downloadAttachments.js";
import {
  clearState,
  getCommentsByInvoiceId,
  getCommentsByERFInvoiceNo,
  getCommentsByARFInvoiceNo,
  getInvoiceByInvoiceIdAndRoleId,
  getVendorByPO,
  updateIPInvoice,
  getAllInvoiceDetailByInvoiceId,
  vendorTaxDetailForCnic,
  changeInvoiceStatus,
  getRefrenceDataList,
  getImportPoData,
  updateIPInvoiceByImport,
  getBatchInvoiceDetails,
  uploadAdditioalDocumentFile,
  putDeptCoordinatorAndReviewerInvoice,
} from "../actions";
import { GetBatchInvoiceDetailsWithname } from "./actions.js";
import InvoiceGuideLine from "../NewInvoice/InvoiceGuidLines/InvoiceGuideLine";
import CustomSnackbar from "../../../CustomSnackbar";
import moment from "moment";
import { dashboardStyle } from "../Components/InvoiceDetails/style";
import { demandType, category, invoiceType } from "../../Home/constant";
import InvoiceCheckboxes from "../Components/InvoiceDetails/InvoiceCheckboxes";
import InvoiceRadioButtons from "../Components/InvoiceDetails/InvoiceRadiobuttons";
import InvoiceTextField from "../Components/InvoiceDetails/InvoiceTextFields";
import InvoiceDetailTextField from "../Components/InvoiceDetails/InvoiceDetailTextFields";
// import PaymentDetail from "../Components/PaymentDetails/PaymentDetail";
import PaymentDetail from "../Components/PaymentDetails/PaymentDetail.js";
import PaymentDetailsTextField from "../Components/PaymentDetails/PaymentDetailsTextField";
import TaxDetail from "../Components/TaxDetails/TaxDetails";
import TaxDetailTextField from "../Components/TaxDetails/TaxDetailTextField";
import { useNavigate } from "react-router-dom";
import { getUserRoles } from "../../Home/actions";
import getParameterByName from "../../../Functions/functions";
import TaxTable_Short from "../NewInvoice/Tables/Tax_Table_Short";
import GL_Table_ProcessInvoice from "../NewInvoice/Tables/GL_Table_ProcessInvoice";
import ConfirmationModal from "../../../components/ConfirmModal/ConfirmationModal";
import AttachmentsCover from "../../../components/Attachments/AttachmentsCover";
import { addZeroes } from "../../../Functions";
import OldDateWarning from "../NewInvoice/InvoiceGuidLines/OldDateWarning";
import TaxTable_Short_Import from "../NewInvoice/Tables/Tax_Table_Short_import";
import PoDetail_Table_Import from "../NewInvoice/Tables/PoDetail_Table_Import";
import Po_ImportReference_Table from "../NewInvoice/Tables/Po_ImportReference_Table";
import Vendor_Table from "../NewInvoice/Tables/Vendor_Table";
import PaymentImport from "../NewInvoice/Payment/PaymentImport";
import WarningBox from "../Components/WarningBox";
import { useParams } from "react-router-dom";
import CommentHistory from "../NewInvoice/Tables/CommentHistory";
import Heading from "../../../StyledComponents/Heading/Heading";
import ExpenseDetail from "../NewInvoice/Tables/ExpenseDetail.js";
import FER_Fuel_General_Allowance from "../NewInvoice/Tables/FERTables/FER_Fuel_General_Allowance.js";
import FER_General from "../NewInvoice/Tables/FERTables/FER_General.js";
import FER_Allowance from "../NewInvoice/Tables/FERTables/FER_Allowance.js";
import { InputAdornment, MenuItem, Select } from "@material-ui/core";
import GL_Table_Detail_HR from "../NewInvoice/Tables/GL_Table_Detail_HR.js";
import GL_Table_V2 from "../NewInvoice/Tables/GL_Table_V2";
import DepartmentCoordinatorRent from "../DepartmentCoordinator/DepartmentCoordinatorRent";
const useStyles = makeStyles(dashboardStyle);

const ProcessInvoiceDetail = () => {
  const classes = useStyles();

  const navigate = useNavigate();
  const invoiceId = getParameterByName("invoiceId");
  const roleId = getParameterByName("roleId");
  const roleName = getParameterByName("roleName");
  const status=getParameterByName("status")
  const vendorCode = getParameterByName("vendorCode");
  const edit = getParameterByName("edit");
  const invoiceStatus = getParameterByName("status");

  const invoicePayload = {
    Invoice_id: invoiceId,
    Vendor_Code: vendorCode,
  };

  const role = {
    roleId: roleId,
    roleName: roleName,
  };

  const [selectedRole, setSelectedRole] = useState(
    role ? { roleName: role?.roleName } : ""
  );

  const [poBasedState, setPoBasedState] = useState("PO");
  const [physicalOrEInvoice, setPhysicalOrEInvoice] = useState("Physical");
  const [attachInvoiceLoading, setAttachInvoiceLoading] = useState(false);
  const [roles, setRoles] = useState([]);

  const [rolesLoading, setRolesLoading] = useState(false);

  const [openInvoiceGuideLine, setOpenInvoiceGuideLine] = useState(false);

  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [statusForPayload, setStatusForPayload] = useState("");
  const [Post, setPost] = useState(true);
  const [commentsList, setCommentsList] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [POImportReference_Table, setPOImportReference_Table] = useState([]);

  // const [isLoading, setIsLoading] = useState(true);

  const [multipleData, setMultipleData] = useState({
    sglInd: [],
    tType: [],
    glAccount: [],
    postingKey: [],
    paymentDetail: [],
    paymentMethod: [],
    paymentTerms: [],
    paymentMethSupp: [],
    poData: [],
    vendorTaxDetail: [],
    currency: [],
    invoice_Type: [],
    erf_ExpenseInvoice_Detail: [],
    fer_Invoice_Detial: [],
  });
  const invoice_attachmentRef = useRef(null);
  const additionalAttachmentRef = useRef(null);
  const [formState, setFormState] = useState({
    delv_Note_No: "",
    courier_Company: "",
    courier_Tracking_No: "",
    created_On: new Date(),
    updated_By: "",
    updated_On: new Date(),
    comments: "",
    aditional_Comments: "",
    po_Date: '',
    plant_Code: "",
    file_name: "",
    quantity: "",
    charge_Account: "",
    cost_Center: "",
    asset_No: "",
    dept_coordinator: "",
    loam_approver: "",
    buyer: "",
    prInitiator: "",
    taxTeam: "",
    paymentTerm: "",
    invoiceDocURL: "",
    isSubmittedByVendor: true,
    supervisorLevel: "",
    sodReviewer: "",
    dcReviewer: "",
    loamReviewer: "",
    supervisorReviewer: "",
    logisticsTeam: "",
    logisticsReviewer: "",
    reviewer1: "",
    reviewer2: "",
    pcdvSegment: "",
    pcdvLocation: "",
    invoiceLocation: "",
    employeeCode: "",
    vP_InvoiceId: 0,
    courier_Tracking_No: "",
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    submission_Date: new Date(),
    // submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,

    cnic: "",

    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: "",
    calculateTax: false,
    eInvoice: true,

    cheque_No: "",
    invoice_Date: moment().format("YYYY-MM-DD"),
    invoice_Id: 0,
    grn_No: "",
    pO_No: "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: 0,
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: [], // paths
    due_Date: "",

    //   for import invoice (extra field)
    currency: "PKR",
    posting_Date: moment().format("YYYY-MM-DD"),
    document_Type: "",
    firstClearText: "",
    secondClearText: "",
    created_By: "",

    // vendor Detail
    vendor_Details: [],
    // =======import invoice some tables are below ==========
    additionalDocIds_array: [], // additional documents in array

    // for Payment detail ("invoice_Payment" for po normal isInititor invoice).
    // ("invoice_Payment_Details" for import invoice) (will chnage).
    invoice_Payment: {
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: false,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: "",
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: new Date(),
    },

    // Tax Table data (invoice_TaxDetails for po normal isInititor invoice)
    // ("invoice_Tax_Details" for import invoice) (will chnage).
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],

    // G/L Account detail. (actually for po_normal isInitiator)
    // (will change it to "invoice_Accounts_Details" for import invoice before hit api)
    invoice_Accounts: [
      // {
      //   accountId: 0,
      //   invoice_Id: 0,
      //   glAccount: "",
      //   costCenter: "",
      //   accountType: "",
      //   amount: 0,
      //   costCenterOwner: "",
      //   stCode: "",
      //   order: "",
      //   profitCenter: "",
      //   wbsElement: "",
      //   created_By: "",
      //   created_On: new Date(),
      //   updated_By: "",
      //   updated_On: new Date(),
      //   fixedAsset: "",
      //   tType: "",
      //   description: "",
      //   expenseDate: "",
      //   horizonId: "",
      //   department: "",
      //   vendorCode: "",
      // },
    ],

    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the PODetail table component.
      // {
      //   poItem: "", //  item #
      //   poNumber: "", // poNumber
      //   refDoc: "", // GRN No
      //   quantity: "", // GRN quantity
      //   val_Loccur: "", // GRN amount
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: 0, // consumed Amount
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   currency: "", // currency
      // },
    ],
    verified: false,
  });

  const [openWarningBox, setOpenWarningBox] = useState(false);
  const [openInvalidWarningDate, setOpenInvalidWarningDate] = useState(false);
  const [importPaymentDetail, setImportPaymentDetail] = useState({
    invoice_Payment_Details: [],
  });
  const [newFormState, setNewFormState] = useState({
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    isPSID: false,
    psid: "",
    urgent: false,
    skipTaxStep: false,
    courier_Tracking_No: "",
    invoice_Id: 0,
    grn_No: "",
    pO_No: "",
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: "",
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    taxTeam: "",
    vendor_Code: "",
    vendor_Name: "",
    invoice_Date: moment().format("YYYY-MM-DD"),
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: "", // paths
    comments: "",
    aditional_Comments: "",
    //   for import invoice (extra field)
    currency: "",
    posting_Date: new Date(),
    document_Type: "",
    firstClearText: "",
    secondClearText: "",
    created_By: "",

    // vendor Detail
    vendor_Details: [],
    // =======import invoice some tables are below ==========

    additionalDocIds: [], // additional documents in array

    due_Date: "",

    cnic: "",
    ntn: "",
    salesTaxCode: "",
    salesTaxAmount: "",
    calculateTax: false,
    eInvoice: true,

    currency: "",

    // for Payment detail
    invoice_Payment: {
      inv_Payment_Id: 0,
      invoice_Id: 0,
      postingKey: "",
      sglInd: "",
      tType: "",
      paymentTerms: "",
      paymentDays: "",
      paymentMethod: "",
      paymentMethSupp: "",
      individualPayee: false,
      account: "",
      amount: 0,
      taxAmount: 0,
      dueOn: "",
      taxCode: "",
      description: "",
      order: "",
      costCenter: "",
      wbsElement: "",
      profitCenter: "",
      createdBy: "",
      createdDate: new Date(),
    },

    // Tax Table
    invoice_TaxDetails: [
      {
        taxId: 0,
        invoice_Id: 0,
        taxType: "",
        taxCode: "",
        amount: "",
        comments: "",
        created_By: "",
        created_On: new Date(),
        updated_By: "",
        updated_On: new Date(),
        taxCardId: 0,
      },
    ],
    // G/L Account detail.
    invoice_Accounts: [
      // {
      //   accountId: 0,
      //   invoice_Id: 0,
      //   glAccount: "",
      //   costCenter: "",
      //   accountType: "", // D/C (debit/ credit)
      //   amount: 0,
      //   costCenterOwner: "",
      //   stCode: "",
      //   order: "",
      //   profitCenter: "",
      //   wbsElement: "",
      //   created_By: "",
      //   created_On: new Date(),
      //   updated_By: "",
      //   updated_On: new Date(),
      //   fixedAsset: "",
      //   tType: "",
      //   description: "",
      //   expenseDate: "",
      //   horizonId: "",
      //   department: "",
      //   vendorCode: "",
      // },
    ],
    // PO Table Detail
    // "pO_Details" this keyword is used acctualy on backend, before hit the api it changes
    invoicePORef_List: [
      // we use this keyword due to reuse the PODetail table component.
      // {
      //   poItem: "", //  item #
      //   poNumber: "", // poNumber
      //   refDoc: "", // GRN No
      //   quantity: "", // GRN quantity
      //   val_Loccur: "", // GRN amount
      //   invoicE_QTY: "", //  consumed quantity
      //   invoicE_VAL: 0, // consumed Amount
      //   inpuT_QTY: "", //  invoice QTY
      //   inpuT_VAL: "", //  Invoice amount
      //   currency: "", // currency
      // },
    ],

    verified: false,
  });

  const [debitBalance, setDebitBalance] = useState(0);
  const [creditBalance, setCreditBalance] = useState(0);

  const [invoiceTaxDetail, setInvoiceTaxDetail] = useState({
    invoice_TaxDetails: [],
  });
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [totalGrnAmount, setTotalGrnAmount] = useState(0);
  const [balance, setBalance] = useState(0);

  const [attachmentURL, setAttachmentURL] = useState("");
  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [gLAccountTotal, setGLAccountTotal] = useState(0);

  useEffect(() => {
    if (newFormState?.invoicePORef_List?.length > 0) {
      let counts = 0;
      for (let i = 0; i < newFormState?.invoicePORef_List?.length; i++) {
        const item = newFormState?.invoicePORef_List[i];
        counts = counts + parseFloat(item.inpuT_VAL);
      }
      setTotalGrnAmount(counts);
    }
  }, [newFormState.invoicePORef_List]);

  // to set po based true or false.
  useEffect(() => {
    if (formState.invoice_Id) {
      if (formState.pO_Based) {
        setPoBasedState("PO");
      } else {
        setPoBasedState("Non-PO");
      }
    }
  }, [formState.invoice_Id]);

  useEffect(() => {
    if (newFormState.pO_Based) {
      const tax_invAmt =
        parseFloat(newFormState?.salesTaxAmount) +
        parseFloat(newFormState?.invoice_Amount);
      const bal =
        Number(totalGrnAmount) +
        Number(newFormState?.salesTaxAmount || 0) +
        gLAccountTotal -
        Number(newFormState?.invoice_Amount || 0);
      const c = Number(bal.toFixed(3));
      setBalance(c);
    }
  }, [
    newFormState?.salesTaxAmount,
    newFormState?.invoice_Amount,
    totalGrnAmount,
    gLAccountTotal,
  ]);

  useEffect(() => {
    let debitt = 0;
    let creditt = 0;
    if (importPaymentDetail?.invoice_Payment_Details.length > 0) {
      for (
        let i = 0;
        i < importPaymentDetail?.invoice_Payment_Details?.length;
        i++
      ) {
        const ele = importPaymentDetail?.invoice_Payment_Details[i];
        if (ele.postingKey === "40") {
          // debit
          debitt = debitt + parseFloat(ele?.amount || 0);
        }
        if (ele.postingKey === "50") {
          // credit
          creditt = creditt + parseFloat(ele?.amount || 0);
        }
        if (ele.postingKey === "31") {
          creditt = creditt + parseFloat(ele?.amount || 0);
        }
      }
      setDebitBalance(debitt);
      setCreditBalance(creditt);
    }
  }, [importPaymentDetail?.invoice_Payment_Details]);

  useEffect(() => {
    if (formState.invoice_Amount !== "") {
      setCreditBalance(formState.invoice_Amount);
    }
  }, [formState.invoice_Amount]);

  useEffect(() => {
    setBalance(creditBalance - debitBalance);
  }, [creditBalance, debitBalance]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setNewFormState((newFormState) => ({
      ...newFormState,
      [name]: value,
    }));

    if (name === "pO_No") {
      getVendorByPO(value, "vendor_Code", setNewFormState);
      // if passing PONumber
      // getPODetails(value, "",setFormState)
      // form dummy data
      // getPODetails(setFormState)
    }
  };

  const showVendorAndPO_NumberForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Deposit"
    ) {
      show = false;
    }

    return show;
  };

  const showVendorCodeForImport = () => {
    let show = selectedRole?.roleName === "Import" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Spare Parts"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Material"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Samples"
    ) {
      show = false;
    }

    return show;
  };

  // to upload the file and get path.
  const poBasedHandler = (e) => {
    setPoBasedState(e.target.value);
    clearState(setFormState);
  };

  const roleHandler = (newValue) => {
    setFormState((formState) => ({
      ...formState,
      isInitiator: newValue.roleName === "I2P Initiator" ? true : false,
      isHR: newValue.roleName === "HR" ? true : false,
      isPCDV: newValue.roleName === "EFDV Initiator" ? true : false,
      isImport: newValue.roleName === "Import" ? true : false,
      isLogistics: newValue.roleName === "Logistic" ? true : false,
    }));

    setSelectedRole(newValue);
  };

  const submitHandler = () => {
    if (formState?.isImport && (status !== "SendToReviewerFromIP" && status !== "SendToReviewerFromIR")) {
      updateIPInvoiceByImport(
        newFormState,
        invoiceTaxDetail,
        importPaymentDetail,
        setNewFormState,
        poBasedState,
        setErrorMessage,
        setSuccessMessage,
        setAttachInvoiceLoading,
        navigate
      );
      setOpenWarningBox(false);
    } else if (formState?.isInitiator  && (status !== "SendToReviewerFromIP" && status !== "SendToReviewerFromIR")) {
      updateIPInvoice(
        newFormState,
        setNewFormState,
        poBasedState,
        setErrorMessage,
        setSuccessMessage,
        setAttachInvoiceLoading,
        navigate
      );
      setOpenWarningBox(false);
    } else  if (formState.invoiceStatus== "SendToReviewerFromIP"||formState.invoiceStatus== "SendToReviewerFromIR") {
       putDeptCoordinatorAndReviewerInvoice(
        newFormState,
        setNewFormState,
        setErrorMessage,
        setSuccessMessage,
        setAttachInvoiceLoading,
        navigate,
        setOpenWarningBox,
        true,
        setPost
      );
      setOpenWarningBox(false);
    }
    setOpenWarningBox(false);
  };

  const [dataLoading, setDataLoading] = useState(false);

  useEffect(() => {
    getRefrenceDataList(
      "invoiceType",
      "invoice_Type",
      () => {},
      setMultipleData
    );
    getRefrenceDataList(
      "PaymentTerm",
      "paymentTerms",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "postingKey",
      "postingKey",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList("sglInd", "sglInd", setFormState, setMultipleData);
    getRefrenceDataList("tType", "tType", setFormState, setMultipleData);

    getRefrenceDataList(
      "PaymentMethod",
      "paymentMethod",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList(
      "PaymentMethodSupp",
      "paymentMethSupp",
      setFormState,
      setMultipleData
    );
    getRefrenceDataList("Currency", "currency", setFormState, setMultipleData);
    getUserRoles(setRoles, setRolesLoading);

    if (invoicePayload && role) {
      vendorTaxDetailForCnic(setFormState, invoicePayload?.Vendor_Code);
      // getInvoiceByInvoiceIdAndRoleId(invoicePayload, role, setFormState);
      // getInvoiceByInvoiceIdAndRoleId(
      //   setIsLoading,
      //   invoicePayload,
      //   role,
      //   setFormState
      // );
      GetBatchInvoiceDetailsWithname(
        () => {},
        setImportPaymentDetail,
        setMultipleData,
        invoicePayload,
        role,
        setFormState,
        setDataLoading,
        setPoBasedState
      );
      // getCommentsByInvoiceId(
      //   setCommentsList,
      //   setCommentsLoading,
      //   invoicePayload?.Invoice_id
      // );
      // if (!formState.isImport) {
      // getAllInvoiceDetailByInvoiceId(
      //   setFormState,
      //   setMultipleData,
      //   invoicePayload?.Invoice_id,
      //   () => {},
      //   setImportPaymentDetail,
      //   importPaymentDetail,
      //   () => {},
      //   () => {},
      //   "",
      //   setDataLoading
      // );
      // }
    }
  }, []);
  useEffect(() => {
    if (invoicePayload && role) {
      if (formState?.invoice_Type === "ERF") {
        getCommentsByERFInvoiceNo(
          setCommentsList,
          setCommentsLoading,
          formState?.invoice_No
        );
      }
        else if (formState?.invoice_Type === "ARF") {
        getCommentsByARFInvoiceNo(
          setCommentsList,
          setCommentsLoading,
          formState?.invoice_No
        );
      }
      else {
        getCommentsByInvoiceId(
          setCommentsList,
          setCommentsLoading,
          invoicePayload?.Invoice_id
        );
      }
    }
  }, [formState.invoice_Type]);
  const [po_Loading, setPo_Loading] = useState(false);

  useEffect(() => {
    if (
      formState?.isImport &&
      formState?.pO_No &&
      formState?.invoicePORef_List?.length === 0
    ) {
      getImportPoData(
        formState?.pO_No,
        invoicePayload?.Invoice_id,
        setFormState,
        setPo_Loading
      );
    }
  }, [formState?.isImport, formState?.pO_No]);

  useEffect(() => {
    let filterd_data = [];
    if (formState?.additionalDocIds?.length > 0) {
      filterd_data = formState.additionalDocIds.filter((e) => Number(e) !== 0);
    }

    setAttachmentURLList((pre) => [
      formState?.invoice_attachment,
      ...filterd_data,
    ]);
    setAttachmentURL(formState?.invoice_attachment);
  }, [formState?.invoice_attachment, formState?.additionalDocIds]);

  useEffect(() => {
    if (newFormState?.additionalDocIds?.length > 0) {
      setAttachmentURLList((pre) => [
        ...pre,
        newFormState?.additionalDocIds[
          newFormState?.additionalDocIds.length - 1
        ],
      ]);
    }
  }, [newFormState?.additionalDocIds]);

  useEffect(() => {
    setNewFormState(formState);
    setNewFormState((newFormState) => ({
      ...newFormState,
      additionalDocIds: [],
    }));
  }, [formState]);

  //  used for show taxdetail when invoice is created by import.

  //  used for show taxdetail when invoice is created by import.
  useEffect(() => {
    if (formState?.taxCard_List?.length > 0 && formState.isImport) {
      let tempArray = [];
      for (let i = 0; i < formState?.taxCard_List?.length; i++) {
        const item = formState?.taxCard_List[i];
        const obj = {
          taxId: 0,
          invoice_Id: invoicePayload?.Invoice_id,
          taxType: item?.taxType,
          taxCode: item?.taxCode,
          amount: formState.invoice_Amount,
          comments: "",
          created_By: "",
          created_On: new Date(),
          updated_By: "",
          updated_On: new Date(),
          taxCardId: 0,
        };
        tempArray.push(obj);
      }
      setInvoiceTaxDetail((formState) => ({
        ...formState,
        invoice_TaxDetails: tempArray,
      }));
    }
  }, [formState?.taxCard_List]);

  useEffect(() => {
    let total = 0;
    if (formState.invoice_Accounts.length > 0) {
      for (let index = 0; index < formState.invoice_Accounts.length; index++) {
        const item = formState.invoice_Accounts[index];
        total = parseFloat(item.amount ? item?.amount : item?.Amount) + total;
      }

      setGLAccountTotal(total);
    }
  }, [formState?.invoice_Accounts]);

  // invoice_attachment: "",
  // additionalDocIds: "", // paths

  // useEffect(() => {
  //   if (!changed && formState?.additionalDocIds.length > 0) {
  //     setNewFormState((newFormState) => ({
  //       ...newFormState,
  //       additionalDocIds: [],
  //     }));
  //     setChanged(true);
  //   }

  // }, [formState.additionalDocIds]);

  const showAttachmentsHandler = (attachment_URL) => {
    setAttachmentURL(attachment_URL);
  };

  const confirmHandler = (e) => {
    e.preventDefault();
    setConfirmationModal(true);
    setConfirmationMessage("Are you sure you want to Proceed?")
  };
  const gltotal = 0;
  useEffect(() => {
    let days = multipleData?.paymentTerms?.filter(
      (item) =>
        item.ReferenceCode === newFormState.invoice_Payment?.paymentTerms
    );
    let date = moment(newFormState?.invoice_Date).format("YYYY-MM-DD");

    setNewFormState((formState) => ({
      ...formState,
      invoice_Payment: {
        ...formState?.invoice_Payment,
        dueOn: moment(date, "YYYY-MM-DD")
          .add(Number(days[0]?.ReferenceProp1), "days")
          .format("YYYY-MM-DD"),
      },
    }));

    //  newFormState?.invoice_Payment
  }, [
    newFormState?.invoice_Payment?.paymentTerms,
    newFormState?.invoice_Payment?.dueOn,
    newFormState?.invoice_Date,
  ]);

  useEffect(() => {
    // if (newFormState.IsImport && newFormState.IsPSID) {
    setNewFormState((formState) => ({
      ...formState,
      invoice_Payment: {
        ...formState?.invoice_Payment,
        paymentMethod: "6",
        paymentMethSupp: "C",
      },
    }));
  }, []);
  const [dragfile, setDragFile] = useState(false);
  const [dragloader, setDragLoader] = useState(false);
  const [docError, setDocError] = useState("");
  const [attachError, setAttachError] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);
  const [attachmentLoader, setAttchmentLoader] = useState(false);
  const [invoicedelete, setInvoiceDelete] = useState("");
  const [deleteLoader, setdeleteLoader] = useState(false);
  const deleteAttachmentFunc = () => {
    const data = {
      Id: invoicedelete?.id,
    };
    setdeleteLoader(true);
    var axios = require("axios");
    var config = {
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}/api/UploadFile/DeleteAttachment`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
      params: data,
    };

    axios(config)
      .then(function (response) {
        const final = attachmentURLList?.filter(
          (x) => x?.path !== invoicedelete?.path
        );
        const files = newFormState.additionalDocIds.filter(
          (x, i) => x.path !== invoicedelete?.path
        );
        setAttachmentURLList(final);

        setNewFormState((formState) => ({
          ...formState,
          additionalDocIds: files,
        }));

        setdeleteLoader(false);
        setOpenWarningBox(false);

        setSuccessMessage(response.data);
      })
      .catch(function (error) {
        setErrorMessage(error.response?.data);
      });
  };
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragLoader(true);
    } else if (e.type === "dragleave") {
      setDragLoader(false);
      setDragFile(true);
    }
  };
  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragLoader(false);

    if (
      // formState?.invoice_attachment === "" &&
      // selectedRole?.roleName != "EFDV Initiator" &&
      e.dataTransfer.files &&
      e.dataTransfer.files[0]
    ) {
      uploadAdditioalDocumentFile(
        e,
        setNewFormState,
        setAttchmentLoader,
        "additionalDocIds",
        additionalAttachmentRef,
        setDocError,
        setAttachError,
        setAlertMessage,
        invoicePayload,
        selectedRole,
        dragfile,
        setDragFile,
        setSuccessMessage
      );
    }
  };
  const isContainEmailFormate = (fileExtension) => {
    const emailExtensions = [
      "eml",
      "msg",
      "pst",
      "mbox",
      "emlx",
      "dbx",
      "mbx",
      "nws",
      "p7m",
      "mht",
      "mhtml",
      "rar",
      "zip",
    ];
    return emailExtensions.includes(fileExtension.toLowerCase());
  };

  return (
    <Card
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
      onDrop={handleDrop}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={dataLoading || dragloader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <CardHeader color="primary" text>
        <CardText
          style={{
            padding: "0px 27px",
            backgroundColor: "#031C30",
            color: "white",
          }}
        >
          <Grid container justifyContent="space-between">
            <Grid item xs={2} sm={3} md={3} lg={6}>
              <h1 style={{ fontSize: "24px" }}>Process Invoice</h1>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <IconButton
                variant="contained"
                style={{ float: "right", marginTop: "1.5%" }}
                onClick={() => navigate("/home")}
              >
                <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
              </IconButton>
            </Grid>
          </Grid>
        </CardText>
      </CardHeader>
      <CardBody>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={attachInvoiceLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Grid container style={{ marginTop: "1px" }}>
          {/* Submitter role */}
          <Grid item xs={12} sm={12} md={12} lg={6}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Typography style={{ color: "black" }}>Submitter Role</Typography>
              <Autocomplete
                sx={{
                  "& .MuiInputBase-root": {
                    height: "30px",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                  },
                  "& .MuiInputBase-input": {
                    marginTop: "-4px", // Adjust this value to move the text up
                    fontSize: 15,
                  },
                }}
                id="submitter_role"
                options={roles}
                size="small"
                value={selectedRole}
                getOptionLabel={(option) =>
                  (option !== "" && `${option?.roleName}`) || ""
                }
                loading={rolesLoading}
                onChange={(event, newValue) => {
                  roleHandler(newValue);
                }}
                disabled
                renderInput={(params) => (
                  <TextField {...params} type="text" name="" required />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={9} lg={9}></Grid>

            {!formState.isImport && !formState.isHR && (
              <InvoiceCheckboxes
                formState={formState}
                setFormState={setFormState}
                selectedRole="IP"
                disabled={true}
              />
            )}
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                {!formState.isImport && !formState.isHR && (
                  <InvoiceRadioButtons
                    formState={formState}
                    setFormState={setFormState}
                    selectedRole="IP"
                    physicalOrEInvoice={physicalOrEInvoice}
                    poBasedState={poBasedState}
                    alignForAttachment={false}
                  />
                )}

                {/* <InvoiceTextField
              newFormState={formState}
              setNewFormState={setFormState}
              selectedRole="IP"
              disabled={true}
              edit={false}
              poBasedState={poBasedState}
              showVendorAndPO_NumberForImport={showVendorAndPO_NumberForImport}
              showVendorCodeForImport={showVendorCodeForImport}
              invoice_attachmentRef={invoice_attachmentRef}
              additionalAttachmentRef={additionalAttachmentRef}
              setAttachInvoiceLoading={setAttachInvoiceLoading}
              //   setAttchmentFile_UI={setAttchmentFile_UI}
              //   attachmentFile_UI={attachmentFile_UI}
              physicalOrEInvoice={physicalOrEInvoice}
              changeHandler={changeHandler}
              alignForAttachment={true}
              setAttachmentURLList={setAttachmentURLList}
              attachmentURLList={attachmentURLList}
              setAttachmentURL={setAttachmentURL}
              showAttachmentsHandler={showAttachmentsHandler}
              setOpenInvalidWarningDate={setOpenInvalidWarningDate}
              multipleData={multipleData}
            />*/}
                <InvoiceDetailTextField
                formState= {formState}
                  newFormState={formState}
                  setNewFormState={setFormState}
                  selectedRole="IP"
                  disabled={true}
                  edit={false}
                  poBasedState={poBasedState}
                  showVendorAndPO_NumberForImport={
                    showVendorAndPO_NumberForImport
                  }
                  showVendorCodeForImport={showVendorCodeForImport}
                  invoice_attachmentRef={invoice_attachmentRef}
                  additionalAttachmentRef={additionalAttachmentRef}
                  setAttachInvoiceLoading={setAttachInvoiceLoading}
                  //   setAttchmentFile_UI={setAttchmentFile_UI}
                  //   attachmentFile_UI={attachmentFile_UI}
                  physicalOrEInvoice={physicalOrEInvoice}
                  changeHandler={changeHandler}
                  alignForAttachment={true}
                  setAttachmentURLList={setAttachmentURLList}
                  attachmentURLList={attachmentURLList}
                  setAttachmentURL={setAttachmentURL}
                  showAttachmentsHandler={showAttachmentsHandler}
                  setOpenInvalidWarningDate={setOpenInvalidWarningDate}
                  multipleData={multipleData}
                />
                {!formState?.isLogistics && (
                  <PaymentDetailsTextField
                    // formState={newFormState}
                    // setFormState={setNewFormState}
                    formState={formState}
                    setFormState={setFormState}
                    multipleData={multipleData}
                    disabled={true}
                    alignForAttachment={true}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={6}
            style={{ paddingLeft: "7px" }}
          >
            <Heading title="Attachment Preview">
              <span>
                {attachmentURL != ""
                  ? attachmentURL == formState?.invoice_attachment
                    ? " (Invoice Attachmnets)"
                    : "(Additional Documents)"
                  : null}
              </span>
            </Heading>

            <AttachmentsCover
              attachmentURLList={attachmentURLList}
              setAttachmentURLList={setAttachmentURLList}
              attachmentURL={attachmentURL}
              setAttachmentURL={setAttachmentURL}
            />
          </Grid>
        </Grid>

        <form onSubmit={confirmHandler} style={{ marginTop: "50 px" }}>
          {/* Check boxes */}

          {/* <InvoiceTextField
            newFormState={newFormState}
            setNewFormState={setNewFormState}
            selectedRole="IP"
            edit={true}
            disabled={false}
            poBasedState={poBasedState}
            showVendorAndPO_NumberForImport={showVendorAndPO_NumberForImport}
            showVendorCodeForImport={showVendorCodeForImport}
            invoice_attachmentRef={invoice_attachmentRef}
            additionalAttachmentRef={additionalAttachmentRef}
            setAttachInvoiceLoading={setAttachInvoiceLoading}
            // setAttchmentFile_UI={setAttchmentFile_UI}
            // attachmentFile_UI={attachmentFile_UI}
            physicalOrEInvoice={physicalOrEInvoice}
            changeHandler={changeHandler}
            alignForAttachment={false}
            setAttachmentURLList={setAttachmentURLList}
            attachmentURLList={attachmentURLList}
            setAttachmentURL={setAttachmentURL}
            showAttachmentsHandler={showAttachmentsHandler}
            setOpenInvalidWarningDate={setOpenInvalidWarningDate}
            multipleData={multipleData}
            fields={false}
            />*/}

          {/* {!formState.isImport && (
            <PaymentDetail
              // formState={newFormState}
              // setFormState={setNewFormState}
              // formState={formState}
              // setFormState={setFormState}
              multipleData={multipleData}
              disabled={true}
              alignForAttachment={true}
            />
         )}*/}

          {/* Tax  */}
          {!formState.isHR &&
            formState.invoice_Type !== "DES" &&
            formState.invoice_Type !== "ERF" &&
            formState.invoice_Type !== "FER" && (
              <>
                <Heading title="Tax" />
                {/* <TaxDetail
   formState={newFormState}
   setFormState={setNewFormState}
   invoice_Amount={newFormState.invoice_Amount}
   edit={"false"}
/>*/}
                <TaxDetailTextField
                  formState={formState}
                  setFormState={setFormState}
                  invoice_Amount={formState.invoice_Amount}
                  edit={"false"}
                />
                {formState?.invoice_No && !formState?.isHR && (
                  <TaxTableV2
                    formState={formState}
                    setFormState={setFormState}
                    invoice_Amount={formState.invoice_Amount}
                    invoicePayload={invoicePayload}
                    edit={false}
                    isProceed={false}
                    show={false}
                    setTaxErrorMsg={() => {}}
                    taxErrorMsg={() => {}}
                  />
                )}
                {formState.isImport &&
                invoiceTaxDetail?.invoice_TaxDetails?.length > 0 ? (
                  <TaxTable_Short_Import
                    formState={newFormState}
                    tempSetFormState={setFormState}
                    invoicePayload={invoicePayload}
                    invoiceTaxDetail_forImport_Inv={invoiceTaxDetail}
                    setInvoiceTaxDetail_forImport_Inv={setInvoiceTaxDetail}
                    disabled={true}
                  />
                ) : (
                  formState.isInitiator &&
                  formState?.invoice_TaxDetails.length > 0 && (
                    <TaxTable_Short
                      formState={newFormState}
                      setFormState={setNewFormState}
                      tempSetFormState={setFormState}
                      invoicePayload={invoicePayload}
                      invoiceTaxDetail_forImport_Inv={invoiceTaxDetail}
                      setInvoiceTaxDetail_forImport_Inv={setInvoiceTaxDetail}
                      disabled={true}
                    />
                  )
                )}
                {formState?.vendor_tax_detail?.length > 0 && (
                  <VendorTaxTable
                    // formState={newFormState}
                    // setFormState={setNewFormState}
                    formState={formState}
                    setFormState={setFormState}
                  />
                )}
              </>
            )}

          <span></span>
          {/* Expense table */}
          {formState.invoice_Type === "ERF" && (
            <ExpenseDetail multipleData={multipleData} />
          )}
          {formState.invoice_Type === "FER" && (
            <>
              <FER_Fuel_General_Allowance multipleData={multipleData} />
            </>
          )}
          {/* G/L Account */}
          {formState?.invoice_Accounts?.length > 0 &&
            formState.invoice_Type !== "ERF" &&
            formState.invoice_Type !== "FER" && (
              <>
                <Typography
                  variant="h4"
                  style={{ margin: "20px 0px 10px 0px" }}
                >
                  <Heading title="G/L Account" />
                </Typography>
                {formState?.isHR ? (
                  <GL_Table_Detail_HR formState={formState} />
                ) : (


                        formState?.invoice_Type === 'Final Settlement - Distributor' ?
                  
                                          <GL_Table_V2
                                           formState={newFormState}
                                            setFormState={setNewFormState}
                                            show={false}
                                            reviwerFlag={ true }
                                            role={"IR"}                        />

                                            :
                  <GL_Table_ProcessInvoice
                    formState={formState}
                    setFormState={setFormState}
                    // formState={newFormState}
                    // setFormState={setNewFormState}
                    setGLAccountTotal={setGLAccountTotal}
                    importPaymentDetail={importPaymentDetail}
                    setImportPaymentDetail={setImportPaymentDetail}
                    disabled={true}
                  />
                )}
              </>
            )}

          {formState?.isImport &&
          formState?.invoicePORef_List?.length > 0 &&
          formState?.pO_Based ? (
            <>
              <Po_ImportReference_Table
                setPOImportReference_Table={setPOImportReference_Table}
                POImportReference_Table={POImportReference_Table}
                loading={po_Loading}
                formState={formState}
                setFormState={setFormState}
                disabled={true}
              />
              <PoDetail_Table_Import
                formState={formState}
                // setSelectedTotal={setSelectedTotal}
                setSelectedTotal={setTotalGrnAmount}
                setFormState={setFormState}
                deletee={false}
                Invoice_id={invoicePayload?.Invoice_id}
                checkedBox={false}
                loading={po_Loading}
                edit={true}
              />
            </>
          ) : (
            <>
              {formState?.pO_Based &&
                formState?.invoicePORef_List?.length > 0 && (
                  <PODetail
                    // formState={newFormState}
                    // setFormState={setNewFormState}
                    formState={formState}
                    setFormState={setFormState}
                    disabled={true}
                    Invoice_id={invoicePayload?.Invoice_id}
                    setSelectedTotal={setTotalGrnAmount}
                  />
                )}
            </>
          )}

          {!formState.pO_Based &&
            newFormState?.invoice_No &&
            formState.invoice_Type !== "ERF" &&
            formState.invoice_Type !== "FER" && (
              <PaymentImport
                formState={formState}
                vendor={{
                  name: formState?.vendor_Name || "",
                  code: formState?.vendor_Code || "",
                }}
                inv_amount={formState?.invoice_Amount}
                invoiceData={{
                  taxCode: formState?.salesTaxCode,
                  taxAmount: Number(formState?.salesTaxAmount),
                  GLInvoice_Accounts: formState?.invoice_Accounts,
                  isPCDV: formState?.isPCDV,
                  vendor_Code: formState?.vendor_Code,
                }}
                setImportPaymentDetail={() => {}}
                setFormState={() => {}}
                formState1={formState}
                multipleData={multipleData}
                edit={true}
                disable={true}
              />
            )}
                    {formState.invoice_Type=='Rent' &&
                                        <Grid container spacing={0} style={{ marginTop: "0px" }}>
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                      
                                            <DepartmentCoordinatorRent 
                                              formState={formState}
                                              setFormState={setFormState}
                                              show={false}
                                              reviwerFlag={false}
                                              role={(selectedRole?.roleName === "Department Coordinator" && formState.invoice_Type=='Rent')?"":"HR"}    />
                      </Grid>
                                      </Grid>
                       }
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <CommentHistory
              commentsList={commentsList}
              commentsLoading={commentsLoading}
            />
          </Grid>
          {/* clearing detail */}
          {formState.isImport &&
            formState.demandType !== "Deposit" &&
            formState?.vendor_Details?.length > 0 && (
              <Grid container spacing={2} style={{ margin: "20px 0px" }}>
                <Grid item xs={12} sm={12} md={3} lg={12}>
                  <Typography
                    variant="h4"
                    style={{ margin: "20px 0px 10px 0px" }}
                  >
                    <Heading title="Clearing Detail" />
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <Typography
                    variant="h5"
                    style={{ color: "black", fontStyle: "bold" }}
                  >
                    First Clearing Text:{" "}
                    <span
                      style={{
                        color: "#999",
                        fontSize: "14px",
                        cursor: "default",
                      }}
                    >
                      {formState?.firstClearText}
                    </span>
                  </Typography>
                </Grid>
                {formState?.isPSID && (
                  <Grid item xs={12} sm={12} md={3} lg={3}>
                    <Typography
                      variant="h5"
                      style={{ color: "black", fontStyle: "bold" }}
                    >
                      Second Clear Text:{` `}
                      <span
                        style={{
                          color: "#999",
                          fontSize: "14px",
                          cursor: "default",
                        }}
                      >
                        {formState?.secondClearText}
                      </span>
                    </Typography>
                  </Grid>
                )}
              </Grid>
            )}
          {(formState.isImport &&
            formState.demandType !== "Deposit" &&
            formState?.vendor_Details?.length > 0 ) || (roleName === "IP" &&  formState?.vendor_Details?.length > 0  )&& (
              <Vendor_Table
                // formState={newFormState}
                // setFormState={setNewFormState}
                formState={formState}
                setFormState={setFormState}
                disabled={true}
              />
            )}
          <Grid item xs={12} sm={12} md={3} lg={3} pl={1}>
            <Typography style={{ color: "black" }}>
              Additional Document:{" "}
            </Typography>
            <TextField
              fullWidth
              size="small"
              sx={{
                // width: "70%",
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-basic"
              variant="outlined"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <input
                      ref={additionalAttachmentRef}
                      type="file"
                      name="additionalDocIds"
                      onChange={(e) =>
                        uploadAdditioalDocumentFile(
                          e,
                          setNewFormState,
                          setAttchmentLoader,
                          "additionalDocIds",
                          additionalAttachmentRef,
                          setDocError,
                          setAttachError,
                          setAlertMessage,
                          invoicePayload,
                          selectedRole,
                          dragfile,
                          setDragFile,
                          setSuccessMessage
                        )
                      }
                      style={{ width: "209px" }}
                      multiple
                    />

                    {attachmentLoader ? <CircularProgress size={24} /> : ""}
                  </InputAdornment>
                ),
              }}
              // FormHelperTextProps={{
              //   className: classes.helperText,
              // }}
              // error={docError ? true : false}
              // helperText={docError ? `${docError}` : null}
            />
            {newFormState?.additionalDocIds?.length > 0 &&
              newFormState?.additionalDocIds?.map((f, index) => {
                const s = f?.path.split("\\");
                const ss = s[s.length - 1];
                // above 2 lines is for get name of file
                return (
                  <>
                    {f?.path !== "" ? (
                      <>
                        <IconButton>
                          <Download
                            onClick={() => {
                              const files = newFormState?.additionalDocIds.find(
                                (x, i) => {
                                  const n = x?.path?.split("\\");
                                  const nn = n[n.length - 1];
                                  return nn === ss;
                                }
                              );
                              downloadAttachments(files?.path);
                            }}
                            color="secondary"
                          />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => {
                            setInvoiceDelete(f);
                            setOpenWarningBox(true);
                          }}
                        >
                          <Delete
                            color="danger"
                            fontSize="small"
                            style={{
                              color:
                                f.role_Name !== selectedRole?.roleName
                                  ? "gray"
                                  : "",
                            }}
                          />
                        </IconButton>

                        <IconButton
                          size="small"
                          onClick={() => {
                            const extension = f.path
                              ?.match(/\.[^.]+$/)[0]
                              .substring(1);
                            const allowedExtensions = [
                              ".png",
                              ".pdf",
                              ".jpg",
                              ".jpeg",
                              ".PNG",
                              ".JPG",
                              ".JPEG",
                              ".PNG",
                              ".PDF",
                            ];
                            const fileExtension = "." + ss.split(".").pop();
                            if (allowedExtensions.includes(fileExtension)) {
                              setAttachmentURL(f);
                            } else {
                              if (isContainEmailFormate(extension)) {
                                downloadAttachments(f.path);
                              } else {
                                setAttachmentURL(f);

                                window.open(
                                  `${process.env.REACT_APP_API_URL}/${f.path}`,
                                  "_blank"
                                );
                              }
                            }
                          }}
                        >
                          <span style={{ fontSize: "12px" }}>{ss}</span>
                        </IconButton>
                        <div></div>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                );
              })}
          </Grid>
          <Grid container style={{ margin: "20px 0px" }}>
                    <Grid item xs={12} sm={12} md={3} lg={12}>
                      <Typography style={{ color: "black" }}>
                        Comments:
                        {/* <span className={classes.asterisk}>*</span> */}
                      </Typography>
                      <TextField
                        fullWidth
                        multiline
                        // rows={2}
                        maxRows={4}
                        // size="small"
                        sx={{
                          // width: "70%",
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        id="outlined-basic"
                        variant="outlined"
                        name="comments"
                        // required={statusForPayload === "SendToIRFromIP" ? true : false}

                        required={newFormState?.isReturn || status=='SendToReviewerFromIR' || status=='SendToReviewerFromIP'}
                        value={newFormState.comments}
                        onChange={changeHandler}
                      />
                    </Grid>
                  </Grid>
                  {Post && (roleName=='Reviewer' && (status=='SendToReviewerFromIP'||status=='SendToReviewerFromIR')) &&   
                  <Grid>
                        <Button
                            color="error"
                            variant="contained"
                            sx={{ ml: 2 }}
                            type="submit"
                            onClick={() =>
                              setNewFormState({
                                ...newFormState,
                                isReject: true,
                                isReturn: true,
                                isProceed: false,
                              })
                            }
                          >
                            Reject
                          </Button>
                          <Button
                            color="secondary"
                            variant="contained"
                            type="submit"
                            sx={{ ml: 2 }}
                            onClick={()=>{
                              setNewFormState({
                                ...newFormState,
                                isReject: false,
                                isReturn: false,
                                isProceed: false,
                              })
                              submitHandler()
                            }}
                          >
                            Approve
                          </Button>
                        </Grid>}
          {/* {newFormState?.comments && (
            <Grid container style={{ margin: "20px 0px" }}>
              <Grid item xs={12} sm={12} md={3} lg={12}>
                <Typography style={{ color: "black" }}>comments</Typography>
                <TextField
                  fullWidth
                  multiline
                  // rows={2}
                  maxRows={4}
                  // size="small"
                  sx={{
                    // width: "70%",
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  id="outlined-basic"
                  variant="outlined"
                  name="comments"
                  disabled={true}
                  value={newFormState.comments}
                  onChange={changeHandler}
                />
              </Grid>
            </Grid>
          )} */}
          {/* {invoiceStatus === "SendToSupervisor" && (
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Typography style={{ color: "black" }}>
                Comments:
              </Typography>
              <TextField
                fullWidth
                multiline
                name="comments"
                value={newFormState?.comments}
                onChange={changeHandler}
                maxRows={4}
                // size="small"
                sx={{
                  // width: "70%",
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                id="outlined-basic"
                variant="outlined"
                required={newFormState?.isReturn}
              />
              <Button
                style={{
                  margin: "2px",
                  marginTop: "6px",
                  color: "white",
                  fontWeight: "700",
                }}
                variant="contained"
                color="secondary"
                type="submit"
                // id="saveAsDraft"
                onClick={() => {
                  setNewFormState((formState) => ({
                    ...formState,
                    isReturn: true,
                    isProceed: false,
                  }));
                  setConfirmationMessage(
                    "Are you sure to Recall  this invoice "
                  );
                  setStatusForPayload("SendToIP");
                  //  setConfirmationModal(true);
                }}
              >
                Recall
              </Button>
            </Grid>
          )} */}
          {/* 3 way check */}
        </form>
      </CardBody>
      {openInvalidWarningDate && (
        <OldDateWarning
          open={openInvalidWarningDate}
          close={() => setOpenInvalidWarningDate(false)}
        />
      )}
      {confirmationModal && (
        <ConfirmationModal
          open={confirmationModal}
          close={() => setConfirmationModal(false)}
          message={confirmationMessage}
          submit={() =>{
            setConfirmationModal(false)
            putDeptCoordinatorAndReviewerInvoice(
              newFormState,
              setNewFormState,
              setErrorMessage,
              setSuccessMessage,
              setAttachInvoiceLoading,
              navigate,
              setOpenWarningBox,
              true,
              setPost)}
          }
          loading={attachInvoiceLoading}
        />
      )}

      {openInvoiceGuideLine && (
        <InvoiceGuideLine
          open={openInvoiceGuideLine}
          close={setOpenInvoiceGuideLine}
        />
      )}
      {successMessage && (
        <CustomSnackbar
          open={successMessage !== ""}
          message={successMessage}
          handleClose={() => setSuccessMessage("")}
          variant="success"
        />
      )}
      {errorMessage && (
        <CustomSnackbar
          open={errorMessage !== ""}
          message={errorMessage}
          handleClose={() => setErrorMessage("")}
          variant="error"
        />
      )}

      {openWarningBox && (
        <WarningBox
          open={openWarningBox}
          close={() => setOpenWarningBox(false)}
          submit={deleteAttachmentFunc}
          message="Are you sure you want to delete an attachment"
          deleteLoader={deleteLoader}
          allow={1}
        />
      )}
    </Card>
  );
};

export default ProcessInvoiceDetail;
